import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=08024a8d&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.106.2__lodash@4.18.1_prettier@2.8.8_vue-t_4005a65e67acd77eac1bc9f1c137ca40/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08024a8d",
  null
  
)

export default component.exports